<template>
  <nav class="drawer-nav" :class="{ hidden: isCover }">
    <div class="top">
      <div class="nav-back" @click="!back ? null : $router.push(back.path)">
        <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:svg-inline="''" v-if="back" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M8.552 14.655L1.954 8.058 8.552 1.46" stroke="#051B5B" stroke-width="1.5"/></svg>
      </div>
      <p class="section-title tx-wg-regular tx-body">
        {{ title }}
        <span class="section-subtitle tx-wg-bold">
          {{ subtitle }}
        </span>
      </p>
    </div>
  </nav>
</template>

<script>
export default {
  data() {
    return {
      open: false
    };
  },
  computed: {
    meta() {
      let meta = {};
      for (let i = 0; i < this.$route.matched.length; i++) {
        meta = { ...meta, ...this.$route.matched[i].meta };
      }
      return meta;
    },
    isCover() {
      return this.$route.name === 'cover';
    },
    title() {
      const chapter = this.meta.chapter;
      if (this.meta.title)
        return `${chapter ? chapter.toString().padStart(2, '0') : ''}. ${this.$t(this.meta.title)}`;
      return '';
    },
    subtitle() {
      return this.$t(this.meta.subtitle);
    },
    back() {
      if (!this.meta.back) return null;
      else return this.$route.matched[this.$route.matched.length - 2];
    }
  }
};
</script>

<style lang="scss" scoped>
.drawer-nav {
  position: fixed;
  left: 0;
  top: 0;
  transition: opacity 0.3s;
  background-color: $col-white;
  color: $col-primary;
  width: 100%;
  padding: 0 $padding/6;
  padding-left: 0;
  height: $drawerHeight;
  z-index: 1001;
  display: flex;
  align-items: center;
  box-shadow: 0px 10px 10px 1px rgba(0, 0, 0, 0.1);
  .top {
    display: flex;
    align-items: center;
    .nav-back {
      width: $padding/2;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      svg {
        height: 12px;
      }
    }
  }
  &.hidden {
    opacity: 0;
    pointer-events: none;
  }
  .back {
    width: $padding/2;
  }
  .section-title {
    text-transform: uppercase;
    .section-subtitle {
      font-weight: bold;
      color: $col-secondary;
      display: inline-block;
    }
  }
}
</style>
